import { MarketCountryCode } from '@axo/shared/types';

export enum CommunicationChannelType {
  Email = 'email',
  Sms = 'sms',
  Phone = 'phone',
  // AI-driven phone calls. Marketing-only channel.
  AiPhone = 'ai_phone',
}

export enum ConsentStateType {
  Given = 'given',
  NotGiven = 'not_given',
  Revoked = 'revoked',
}

export type ConfigType =
  | 'GENERAL_TERMS'
  | 'DATA_RETENTION'
  | 'MARKETING'
  | 'CREDIT_STATUS'
  | 'GENERAL_TERMS_WHITE_LABEL'
  | 'DATA_RETENTION_WHITE_LABEL';

export enum ConsentType {
  Marketing = 'marketing',
  Transactional = 'transactional',
}

export type Partner = {
  ID: number;
  Name: string;
  BrandID: string;
  Active: boolean;
};

export type ConsentConfigSnapshot = {
  ID: number;
  Country: MarketCountryCode;
  TextNO: string;
  TextFI: string;
  TextDK: string;
  TextSE: string;
  TextEN: string;
  Partners: Partner[];
  ConfigType: ConfigType;
};

export type ConsentConfigVersion = {
  ID: number;
  Country: MarketCountryCode;
  TextNO: string;
  TextFI: string;
  TextDK: string;
  TextSE: string;
  TextEN: string;
  Partners: Partner[];
};

export type ConsentItems = {
  Items: ConsentData[];
};

export type ConsentData = {
  Channel: CommunicationChannelType;
  Country: MarketCountryCode | string;
  CustomerID: string;
  PartnerID: number;
  OriginBrandID: string;
  OriginAction: string;
  State: ConsentStateType;
  Transactional: boolean;
};

export type ConsentConfigData = {
  // Optional: the consent endpoint derives the customer from the session token
  // when omitted (person-token flow); still sent by callers that have it.
  CustomerID?: string;
  Country: MarketCountryCode | string;
  ConfigType: ConfigType;
  OriginBrandID: string;
  ExternalVersion?: string;
  ConfigID?: number;
  OriginAction?: string;
  Lang?: string;
  ForceGiven?: boolean;
};

export type ConsentConfig = {
  Config?: ConsentConfigData;
};

export type UpdateConsentData = {
  Channel: CommunicationChannelType;
  Country: MarketCountryCode | string;
  CustomerID: string;
  PartnerID: number;
  OriginBrandID: string;
  OriginAction: string;
  State: ConsentStateType;
  Transactional: boolean;
};

export type ConsentTypeByState = {
  [K in keyof ConsentType]: ConsentStateType;
};

export type ConsentTypeByChannel = {
  [K in keyof CommunicationChannelType]: ConsentTypeByState;
};

export type PartnerConsent = {
  [key: number | string]: ConsentTypeByChannel;
};

export type PartnerConsentChanges = {
  PartnerChanges: PartnerConsent;
  Country: MarketCountryCode | string;
  CustomerID: string;
  OriginBrandID: string;
  OriginAction: string;
};
